import Vue from 'vue';
import Vuex from 'vuex';
import ConfigurationRepository from './api/configuration/ConfigurationRepository';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: '',
    user: {},
    selectedGroup: {},
    salons: [],
    salonsCopy: [],
    devices: [],
    config: {},
    cssConfig: {},
    loaded: false,
    apiCall: false,
    expired: false,
    navigating: false,
  },
  mutations: {
    set_navigating(state, payload) {
      state.navigating = payload;
    },
    set_expired(state, payload) {
      state.expired = payload;
    },
    set_api_call(state, payload) {
      state.apiCall = payload;
    },
    set_groups(state, payload) {
      state.user.groups = payload;
    },
    set_store_state(state, payload) {
      state.loaded = payload;
    },
    set_active_group(state, payload) {
      state.selectedGroup = payload;
    },
    set_user(state, payload) {
      state.user = payload.user;
      // state.selectedGroup = payload.user.groups[0];
      const group = localStorage.getItem('group');
      if (group === undefined || group === null) {
        if (payload.user.groups.length === 0) {
          state.selectedGroup = { id: 1, name: 'No available groups' };
        } else {
          state.selectedGroup = payload.user.groups[0];
        }
      } else {
        const selectedGroup = JSON.parse(group);
        if (this.getters.groups.some(x => selectedGroup.id === x.id)) {
          state.selectedGroup = selectedGroup;
        } else {
          state.selectedGroup = payload.user.groups[0];
        }
      }
    },
    update_user(state, payload) {
      state.user.firstName = payload.firstName;
      state.user.lastName = payload.lastName;
    },
    set_token(state, payload) {
      localStorage.setItem('token', payload);
      state.token = payload;
    },
    logout(state) {
      state.token = '';
      state = {
        token: '',
        user: {},
        selectedGroup: {},
        salons: [],
        salonsCopy: [],
        devices: [],
        config: {},
        cssConfig: {},
        defaultCss: {},
        htmlContact: [],
      };
    },
    set_salons_list(state, payload) {
      state.salons = payload;
    },
    set_salons_list_copy(state, payload) {
      state.salonsCopy = payload;
    },
    set_devices(state, payload) {
      state.devices = payload;
    },
    revert_salons(state, payload) {
      state.salons = payload;
    },
    set_css_config(state, payload) {
      state.cssConfig = payload;
    },
    set_backend_config(state, payload) {
      state.backendConfig = payload;
    },
    set_html_contact(state, payload) {
      state.htmlContact = payload;
    },
    set_default_css(state, payload) {
      state.defaultCss = payload;
    },
  },
  actions: {
    loginCheck({ commit }) {
      return new Promise((resolve) => {
        resolve(this.getters.isLoggedIn);
      });
    },
    setConfig({ commit }, payload) {
      return new Promise((resolve) => {
        try {
          const config = payload;
          const cssConfig = JSON.parse(payload.backendConfig.CSS_FILE);
          const htmlContact = JSON.parse(payload.backendConfig.CONTACT_HTML);
          delete config.backendConfig.CONTACT_HTML;
          delete config.backendConfig.CSS_FILE;
          const { backendConfig } = config;
          const css = {};
          const defaultCss = {};
          Object.keys(cssConfig).forEach((v, k) => {
            css[v] = cssConfig[v].value;
            defaultCss[v] = cssConfig[v].default;
          });
          commit('set_css_config', css);
          commit('set_backend_config', backendConfig);
          commit('set_html_contact', htmlContact);
          commit('set_default_css', defaultCss);
          resolve('config_set');
        } catch (error) {
          const defaultConfig = ConfigurationRepository.baseConfig();
          const cssConfig = defaultConfig.backendConfig.CSS_FILE;
          const htmlContact = JSON.parse(defaultConfig.backendConfig.CONTACT_HTML);
          delete defaultConfig.backendConfig.CONTACT_HTML;
          delete defaultConfig.backendConfig.CSS_FILE;
          const { backendConfig } = defaultConfig;
          const css = {};
          const defaultCss = {};
          Object.keys(cssConfig).forEach((v, k) => {
            css[v] = cssConfig[v].value;
            defaultCss[v] = cssConfig[v].default;
          });
          commit('set_css_config', css);
          commit('set_backend_config', backendConfig);
          commit('set_html_contact', htmlContact);
          commit('set_default_css', defaultCss);
          resolve('config_set');
        }
      });
    },
    setDevices({ commit }, payload) {
      return new Promise((resolve) => {
        commit('set_devices', payload);
        resolve('devices_set');
      });
    },
    setSelectedGroup({ commit }, payload) {
      return new Promise((resolve) => {
        commit('set_active_group', payload);
        resolve('group_changed');
      });
    },
    setSalons({ commit }, payload) {
      return new Promise((resolve) => {
        commit('set_salons_list', payload);
        // commit('set_salons_list_copy', payload);
        resolve('salons_updated');
      });
    },
    revertCopy({ commit }, payload) {
      return new Promise((resolve) => {
        commit('revert_salons', payload);
        resolve('salons_restored');
      });
    },
    setToken({ commit }, payload) {
      return new Promise((resolve) => {
        commit('set_token', payload);
        resolve('token_set');
      });
    },
    setUser({ commit }, payload) {
      return new Promise((resolve) => {
        payload.user.username = payload.user.login;
        payload.user.login = null;
        commit('set_user', payload);
        resolve();
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('logout');
        localStorage.removeItem('token');
        resolve('logged out');
      });
    },
    navigating({ commit }, payload) {
      return new Promise((resolve) => {
        commit('set_navigating', payload);
        resolve();
      });
    },
  },
  getters: {
    navigating:
      state => state.navigating,
    token:
      state => state.token,
    isLoggedIn:
      state => !!state.token,
    userName(state) {
      return `${state.user.firstName} ${state.user.secondName}`;
    },
    groups:
      state => state.user.groups,
    user:
      state => state.user,
    isAdmin(state) {
      return state.user.role === 'ADMINISTRATOR' || state.user.role === 'OPTIGUARD';
    },
    isDirector(state) {
      return state.user.role === 'SUPERVISOR';
    },
    role:
      state => state.user.role,
    tenant:
      state => state.user.tenantId,
    selectedGroup:
      state => state.selectedGroup,
    salons:
      state => state.salons,
    salonsCopy:
      state => state.salonsCopy,
    devices:
      state => state.devices,
    backendConfig:
      state => state.backendConfig,
    cssConfig:
      state => state.cssConfig,
    delimiter:
      state => state.backendConfig.CSV_DELIMITER,
    logo:
      state => state.backendConfig.LOGO_FILE,
    loaded:
      state => state.loaded,
    apiCall:
      state => state.apiCall,
    userId:
      state => state.user.id,
    expired:
      state => state.expired,
    htmlContact:
      state => state.htmlContact,
    defaultCss:
      state => state.defaultCss,
  },
});
